import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const FileIconContainer = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: ${({ theme }) => theme.palette.grey[100]};
`;

export const UploadContainer = styled.div<{ $dragActive: boolean }>`
  gap: 8px;
  display: flex;
  padding: 20px;
  margin: 10px 0;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  border: 1px dashed ${({ theme }) => theme.palette.primary.main};
  background: ${({ $dragActive, theme }) => ($dragActive ? theme.palette.primary.light : theme.palette.common.white)};

  h1 {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.17px;
  }
`;

export const UploadButton = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 16px;
  font-weight: 700;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin: 10px 0;
  padding: 10px 20px;
  justify-content: space-between;
  border-radius: 8px;
`;

export const FileContainer = styled(Container)`
  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
  }
`;

export const FileContainerUploading = styled(Container)`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  background: ${({ theme }) => theme.tint.primary.light};
`;

export const FileContainerUploadingError = styled(Container)`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.error.main};
  background: ${({ theme }) => theme.palette.error.light};
`;

export const FileName = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 0;
`;

export const FileData = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 0 !important;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  background-color: ${({ theme }) => theme.palette.primary.light};
  border-radius: 3px;
  overflow: hidden;
`;

export const ProgressBarFill = styled.div<{ $progress: number }>`
  height: 100%;
  width: ${({ $progress }) => $progress}%;
  background-color: ${({ theme }) => theme.palette.primary.main};
  border-radius: 3px;
  transition: width 0.3s ease;
`;

export const ProgressText = styled.span`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 12px;
  font-weight: 500;
  margin-left: 8px;
`;
